<template>
  <div>
    <div>
      <resourcesUpload ref='resourcesUpload'></resourcesUpload>
    </div>
    <div>
      <span>1.题干为必填项2.难易程度为必填项3.正确答案为必填项，正确答案必须为大写字母，并且所填的字母前面选项有相关内容(不符合数据将自动过滤去除)</span>
      <el-table max-height="630" :data="dataIm" border style="width: 100%;margin-top: 5px">
        <el-table-column
          align="center"
          prop="name"
          label="题干"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="选项"
          min-width="150"
        >
          <template slot-scope='scope'>
            <div style="display: flex;flex-wrap: wrap">
              <span style="margin-right: 10px" v-for="item in scope.row.options">{{Number(item.number) | change}}.{{item.option}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="难易程度"
          label="难易程度"
          min-width="40"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="introduce"
          label="解析"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="正确答案"
          label="正确答案"
          min-width="50"
        >
        </el-table-column>
      </el-table>
    </div>
    <div>
      <ImportsCom
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        style="display: inline-block"
      ></ImportsCom>
    </div>
    <div style="text-align: center">
      <el-button :disabled="isDis" type="success" @click="save">提交</el-button>
    </div>
  </div>
</template>

<script>
import resourcesUpload from '@/views/testManagement/resourcesUpload';
import ImportsCom from '@/views/testManagement/imports/ImportsCom';
import filters from '@/api/filters.js' //局部引入过滤器
export default {
  filters,
  name: 'ImportTest',
  components:{
    ImportsCom,
    resourcesUpload
  },
  data(){
    return{
      isDis:true,
      category_array:[],
      value_array:[],
      dataIm:[],
    }
  },
  mounted() {
    // debugger
  },
  methods:{
    beforeUpload(file) {
      //导入
      var a = file;
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: "请不要上传大于1m的文件!",
        type: "warning",
      });
      return false;
    },
    handleSuccess({ results, header }) {
      //导入内容
      this.value_array = [];
      this.accounted = [];
      this.phoneed = [];
      this.dataIm = [];
      this.dataed = [];
        // console.log("223", results);
      let isTrueArr = []
      let name = ['题干','解析','难易程度','选项A','选项B','选项C','选项D','选项E','选项F','正确答案']
      for(var key in results[0]){
        isTrueArr.push(key)
      }
      let isTrue = true
      isTrueArr.map((item,index)=>{
        if(name.indexOf(item) == -1){
          isTrue = false
        }
      })
      if(!isTrue){
        this.$message.error('请下载使用正确模板导入数据')
        this.isDis = true
        return
      }
      results.map(item=>{
        if(item.题干){
          item.name = item.题干
        }else {
          item.name = ''
        }
        if(item.难易程度){
          if(item.难易程度 =="难"){
            item.question_difficulty = 1
          }else  if(item.难易程度 =="中"){
            item.question_difficulty = 2
          }else if(item.难易程度 =="易"){
            item.question_difficulty = 3
          }
        }else {
          item.question_difficulty = ''
        }
        if(item.解析){
          item.introduce = item.解析
        }else {
          item.introduce=''
        }

        item.options = []
        let num = 0
        if(item.正确答案){
          if(item.选项A){
            item.options.push({
              number:num,
              option:item.选项A,
              answer:item.正确答案.indexOf("A") != -1?1:0 || item.正确答案.indexOf("Ａ") != -1?1:0
            })
            num ++
          }
          if(item.选项B){
            item.options.push({
              number:num,
              option:item.选项B,
              answer:item.正确答案.indexOf("B") != -1?1:0 || item.正确答案.indexOf("Ｂ") != -1?1:0
            })
            num ++
          }
          if(item.选项C){
            item.options.push({
              number:num,
              option:item.选项C,
              answer:item.正确答案.indexOf("C") != -1?1:0 || item.正确答案.indexOf("Ｃ") != -1?1:0
            })
            num ++
          }
          if(item.选项D){
            item.options.push({
              number:num,
              option:item.选项D,
              answer:item.正确答案.indexOf("D") != -1?1:0 || item.正确答案.indexOf("Ｄ") != -1?1:0
            })
            num ++
          }
          if(item.选项E){
            item.options.push({
              number:num,
              option:item.选项E,
              answer:item.正确答案.indexOf("E") != -1?1:0 || item.正确答案.indexOf("Ｅ") != -1?1:0
            })
            num ++
          }
          if(item.选项F){
            item.options.push({
              number:num,
              option:item.选项F,
              answer:item.正确答案.indexOf("F") != -1?1:0
            })
            num ++
          }
          let numTrue = 0
          let arr = ['A','B','C','D','E','F']
          arr.map(item1=>{
            if(item.正确答案.indexOf(item1) != -1){
              numTrue++
            }
          })
          if(numTrue>1){
            item.question_type = 2
          }else {
            if(item.options.length == 2){
              item.question_type = 3
            }else {
              item.question_type = 1
            }
          }
        }
        if(item.options.length>0){
          let num = ''
          item.options.map(item2=>{
            num += item2.answer
          })
          item.answer = parseInt(num,2)
        }
      })
      var data = results

      data.map((item, index) => {
        if (!item.name) {
          item.name = "";
          data.splice(index, 1);
        }
      });
      data.map((item, index) => {
        if (!item.question_difficulty) {
          item.question_difficulty = "";
          data.splice(index, 1);
        }
      });
      data.map((item, index) => {
        if (!item.正确答案) {
          item.正确答案 = "";
          data.splice(index, 1);
        }
      });
      data.map((item, index) => {
        item.isTrue = false
        item.options.map((item1,index1)=>{
          item1.number = Number(item1.number)
          if(item1.answer == 1){
            item.isTrue = true
          }
        })
      });
      data.map((item, index) => {
        if(!item.isTrue){
          data.splice(index, 1);
        }
      });
      this.dataIm = data
      this.isDis = this.dataIm.length>0?false:true


    },
    save(){
      this.value_array = []
      // console.log(this.dataIm)
      let v = this.$refs.resourcesUpload.searchData.zsdName;
      // console.log(v)
      if(v.length>0){
        v.map(item=>{
          this.category_array.push({node_id:item})
        })
      }
      if(this.dataIm.length>0){
        this.dataIm.map(item=>{
          this.value_array.push({
            name:item.name,
            introduce:item.introduce,
            question_difficulty:item.question_difficulty,
            question_type:item.question_type,
            answer:item.answer,
            options:item.options
          })
        })
      }
      let data = {
        category_array:this.category_array,
        value_array:this.value_array
      }
      // console.log(1111,data)
      this.$post(this.$api.resourceQuestionImport,data).then(res=>{
        if(res.code == 0){
          this.$message.success("导入成功")
          this.$emit("successClose")
        }
      })
    }
  }
};
</script>

<style scoped>

</style>
